<template>
  <div class="card card-custom card-transparent">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div class="wizard wizard-4" id="kt_wizard_v4" data-wizard-state="step-first" data-wizard-clickable="true">
        <!--begin: Wizard Nav-->
        <div class="wizard-nav">
          <div class="wizard-steps">
            <div class="wizard-step" data-wizard-type="step" data-wizard-state="current">
              <div class="wizard-wrapper">
                <div class="wizard-number">1</div>
                <div class="wizard-label">
                  <div class="wizard-title">Penerapan Perizinan Berusaha</div>
                  <div class="wizard-desc">Penerapan Perizinan Berusaha</div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">2</div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    Penyederhanaan Perizinan Berusaha Sektor
                  </div>
                  <div class="wizard-desc">
                    Penyederhanaan Perizinan Berusaha Sektor
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">3</div>
                <div class="wizard-label">
                  <div class="wizard-title">Peningkatan Iklim Investasi</div>
                  <div class="wizard-desc">Peningkatan Iklim Investasi</div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-label">
                  <div class="wizard-title">Bukti Verifikasi</div>
                  <div class="wizard-desc">
                    Upload Bukti Verifikasi Lapangan
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body-->
        <div class="card card-custom card-shadowless rounded-top-0">
          <div class="card-body p-0">
            <div class="row justify-content-center py-12 px-0 py-lg-15 px-lg-0">
              <div class="col-xl-12 col-xxl-11">
                <!--begin: Wizard Form-->
                <form class="form mt-0 mt-lg-10" id="kt_form">
                  <!--begin: Wizard Step 1-->
                  <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
                    <div style="background-color: #1bc5bd" class="card card-custom">
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Penerapan Perizinan
                          Berusaha berdasarkan fakta yang ada dengan memilih
                          data yang sesuai. Dokumen lampiran yang diunggah
                          adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow">halaman pengesahan</strong>
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Unggah</th>
                            <th style="display: none">Download</th>
                            <th style="display: none">Hapus</th>
                            <th style="display: none">Pilihan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Penyusunan NSPK terkait penerapan perizinan
                                berusaha</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Untuk Kementerian Negara/ Lembaga (K/L) yang telah
                              memiliki NSPK, yang dimaksud dalam tolok ukur di
                              sini adalah konsultasi dalam rangka evaluasi atas
                              NSPK yang sudah ada. Termasuk jika ada KBLI yang
                              belum diatur/diampu di dalam PP No. 5 Tahun 2021.
                              Penilaian konsultasi pengusulan NSPK dengan
                              Kementerian terkait lainnya dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a1_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a1_file1')" accept=".pdf" type="file" id="file"
                                ref="p1a1_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a1_file1')" v-b-tooltip.hover
                                title="Undangan rapat konsultasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a1_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a1_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1a1_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a1_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a1_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a1_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file1_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file1_status',
                                    dataVerlap.p1a1_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a1_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a1_file1_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file1_status',
                                    dataVerlap.p1a1_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a1_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a1_file2')" accept=".pdf" type="file" id="file"
                                ref="p1a1_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a1_file2')" v-b-tooltip.hover
                                title="Undangan rapat konsultasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a1_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a1_file2" target="_blank">
                                <button v-if="this.dataVerlap.p1a1_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a1_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a1_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a1_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file2_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file2_status',
                                    dataVerlap.p1a1_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a1_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a1_file2_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file2_status',
                                    dataVerlap.p1a1_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a1_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a1_file3')" accept=".pdf" type="file" id="file"
                                ref="p1a1_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a1_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a1_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a1_file3" target="_blank">
                                <button v-if="this.dataVerlap.p1a1_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a1_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a1_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a1_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file3_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file3_status',
                                    dataVerlap.p1a1_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a1_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a1_file3_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file3_status',
                                    dataVerlap.p1a1_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a1_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a1_file4')" accept=".pdf" type="file" id="file"
                                ref="p1a1_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a1_file4')" v-b-tooltip.hover title="Notula Rapat"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a1_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a1_file4" target="_blank">
                                <button v-if="this.dataVerlap.p1a1_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a1_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a1_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a1_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file4_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file4_status',
                                    dataVerlap.p1a1_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a1_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a1_file4_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file4_status',
                                    dataVerlap.p1a1_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a1_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a1_file5')" accept=".pdf" type="file" id="file"
                                ref="p1a1_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a1_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto rapat konsultasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a1_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a1_file5" target="_blank">
                                <button v-if="this.dataVerlap.p1a1_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a1_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a1_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a1_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file5_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file5_status',
                                    dataVerlap.p1a1_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a1_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a1_file5_status" @change="
                                  submitVerifikasi(
                                    'p1a1_file5_status',
                                    dataVerlap.p1a1_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a1_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada harmonisasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Pilihan pada indikator dan tolok ukur ini
                              menyesuaikan dengan Pilihan pada indikator
                              Penyusunan NSPK terkait penerapan perizinan
                              berusaha. Penilaian harmonisasi pengusulan NSPK
                              dengan Kementerian terkait lainnya
                              (sekurang-kurangnya melibatkan Kementerian
                              Koordinator Bidang Perekonomian, Sekretariat
                              Kabinet, atau Kementerian Investasi/BKPM)
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a2_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a2_file1')" accept=".pdf" type="file" id="file"
                                ref="p1a2_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a2_file1')" v-b-tooltip.hover
                                title="Undangan rapat harmonisasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a2_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a2_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1a2_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a2_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a2_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a2_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file1_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file1_status',
                                    dataVerlap.p1a2_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a2_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a2_file1_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file1_status',
                                    dataVerlap.p1a2_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a2_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a2_file2')" accept=".pdf" type="file" id="file"
                                ref="p1a2_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a2_file2')" v-b-tooltip.hover
                                title="Undangan rapat harmonisasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a2_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a2_file2" target="_blank">
                                <button v-if="this.dataVerlap.p1a2_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a2_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a2_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a2_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file2_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file2_status',
                                    dataVerlap.p1a2_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a2_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a2_file2_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file2_status',
                                    dataVerlap.p1a2_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a2_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a2_file3')" accept=".pdf" type="file" id="file"
                                ref="p1a2_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a2_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a2_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a2_file3" target="_blank">
                                <button v-if="this.dataVerlap.p1a2_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a2_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a2_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a2_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file3_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file3_status',
                                    dataVerlap.p1a2_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a2_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a2_file3_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file3_status',
                                    dataVerlap.p1a2_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a2_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a2_file4')" accept=".pdf" type="file" id="file"
                                ref="p1a2_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a2_file4')" v-b-tooltip.hover title="Notula Rapat"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a2_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a2_file4" target="_blank">
                                <button v-if="this.dataVerlap.p1a2_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a2_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a2_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a2_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file4_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file4_status',
                                    dataVerlap.p1a2_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a2_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a2_file4_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file4_status',
                                    dataVerlap.p1a2_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a2_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a2_file5')" accept=".pdf" type="file" id="file"
                                ref="p1a2_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a2_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto rapat" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a2_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a2_file5" target="_blank">
                                <button v-if="this.dataVerlap.p1a2_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a2_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a2_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a2_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file5_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file5_status',
                                    dataVerlap.p1a2_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a2_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a2_file5_status" @change="
                                  submitVerifikasi(
                                    'p1a2_file5_status',
                                    dataVerlap.p1a2_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a2_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="3">3</td>
                            <td rowspan="3">
                              Apakah ada dokumen NSPK terkait penerapan
                              Perizinan Berusaha?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio :aria-describedby="ariaDescribedby" name="p1a3_nilai"
                                  v-model="dataVerlap.p1a3_nilai" value="25" @change="
                                    submitNilaiRadio(
                                      'p1a3_nilai',
                                      dataVerlap.p1a3_nilai
                                    )
                                    ">Ada, sudah disahkan</b-form-radio>
                                <b-form-radio :aria-describedby="ariaDescribedby" name="p1a3_nilai"
                                  v-model="dataVerlap.p1a3_nilai" value="10" @change="
                                    submitNilaiRadio(
                                      'p1a3_nilai',
                                      dataVerlap.p1a3_nilai
                                    )
                                    ">Ada, belum disahkan</b-form-radio>
                                <b-form-radio :aria-describedby="ariaDescribedby" name="p1a3_nilai"
                                  v-model="dataVerlap.p1a3_nilai" value="0" @change="
                                    submitNilaiRadio(
                                      'p1a3_nilai',
                                      dataVerlap.p1a3_nilai
                                    )
                                    ">Belum ada</b-form-radio>
                              </b-form-group>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a3_file1')" accept=".pdf" type="file" id="file"
                                ref="p1a3_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a3_file1')" v-b-tooltip.hover
                                title="Peraturan Menteri/ Peraturan Kepala Badan tentang NSPK terkait perizinan berusaha berbasis risiko (jika sudah disahkan)"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a3_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a3_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1a3_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a3_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a3_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a3_nilai_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a3_nilai_status" @change="
                                  submitVerifikasi(
                                    'p1a3_nilai_status',
                                    dataVerlap.p1a3_nilai_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a3_nilai_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a3_nilai_status" @change="
                                  submitVerifikasi(
                                    'p1a3_nilai_status',
                                    dataVerlap.p1a3_nilai_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a3_nilai_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input @change="onFileChanged($event, 'p1a3_file2')" accept=".pdf" type="file" id="file"
                                ref="p1a3_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a3_file2')" v-b-tooltip.hover
                                title="Draf Permen/ Peraturan Kepala Badan tentang NSPK terkait perizinan berusaha berbasis risiko (jika belum disahkan)"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a3_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a3_file2" target="_blank">
                                <button v-if="this.dataVerlap.p1a3_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a3_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a3_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Penilaian ada tidaknya dokumen NSPK terkait
                                    penerapan Perizinan berusaha dilakukan
                                    dengan ketentuan tersedia dokumen NSPK
                                    terkait penerapan Perizinan berusaha dalam
                                    lembaran negara. Untuk penetapan bobot
                                    penilaian: <br />
                                    1. Nilai “Ada, sudah disahkan” apabila
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, belum disahkan” apabila
                                    ketentuan di atas tidak terpenuhi namun
                                    sudah tersedia dalam bentuk naskah/dokumen
                                    usulan. <br />
                                    3. Nilai “Belum ada” apabila ketentuan di
                                    atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada kegiatan Sosialisasi NSPK Penerapan
                              Perizinan Berusaha?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya Sosialisasi NSPK Penerapan
                              Perizinan Berusaha dilakukan dengan ketentuan:
                              sosialisasi dilakukan sekurang-kurangnya 1 kali
                              dalam 3 bulan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a4_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Sosialisasi dilakukan secara Nasional
                                  sekurang-kurangnya dilakukan di tingkat
                                  Provinsi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a4_file1')" accept=".pdf" type="file" id="file"
                                ref="p1a4_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a4_file1')" v-b-tooltip.hover title="Undangan sosialisasi"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a4_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a4_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1a4_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a4_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a4_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a4_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file1_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file1_status',
                                    dataVerlap.p1a4_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a4_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a4_file1_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file1_status',
                                    dataVerlap.p1a4_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a4_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a4_file2')" accept=".pdf" type="file" id="file"
                                ref="p1a4_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a4_file2')" v-b-tooltip.hover title="Undangan sosialisasi"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a4_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a4_file2" target="_blank">
                                <button v-if="this.dataVerlap.p1a4_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a4_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a4_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a4_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file2_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file2_status',
                                    dataVerlap.p1a4_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a4_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a4_file2_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file2_status',
                                    dataVerlap.p1a4_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a4_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a4_file3')" accept=".pdf" type="file" id="file"
                                ref="p1a4_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a4_file3')" v-b-tooltip.hover title="Daftar hadir peserta"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a4_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a4_file3" target="_blank">
                                <button v-if="this.dataVerlap.p1a4_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a4_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a4_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a4_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file3_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file3_status',
                                    dataVerlap.p1a4_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a4_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a4_file3_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file3_status',
                                    dataVerlap.p1a4_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a4_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a4_file4')" accept=".pdf" type="file" id="file"
                                ref="p1a4_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a4_file4')" v-b-tooltip.hover title="Notula Sosialisasi"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a4_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a4_file4" target="_blank">
                                <button v-if="this.dataVerlap.p1a4_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a4_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a4_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a4_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file4_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file4_status',
                                    dataVerlap.p1a4_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a4_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a4_file4_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file4_status',
                                    dataVerlap.p1a4_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1a4_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1a4_file5')" accept=".pdf" type="file" id="file"
                                ref="p1a4_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1a4_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto rapat" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1a4_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1a4_file5" target="_blank">
                                <button v-if="this.dataVerlap.p1a4_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1a4_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1a4_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1a4_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file5_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file5_status',
                                    dataVerlap.p1a4_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1a4_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1a4_file5_status" @change="
                                  submitVerifikasi(
                                    'p1a4_file5_status',
                                    dataVerlap.p1a4_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1a4_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Integrasi sistem Kementrian Negara/Lembaga
                                dengan sistem OSS</b>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">
                              Apakah memiliki sistem di K/L yang terintegrasi
                              dengan OSS atau menggunakan sistem OSS dengan hak
                              akses?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian integrasi sistem atau penggunaan hak
                              akses OSS oleh kementerian negara/lembaga
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1b1_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11" style="text-align: justify">
                                  Semua pemrosesan permohonan perizinan berusaha
                                  sektor berdasarkan lampiran PP No. 5 Tahun
                                  2021 yang menjadi kewenangannya menggunakan
                                  sistem K/L yang terintegrasi dengan OSS
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1b1_file1')" accept=".pdf" type="file" id="file"
                                ref="p1b1_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1b1_file1')" v-b-tooltip.hover
                                title="Buku panduan sistem sistem KL yang terintegrasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1b1_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1b1_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1b1_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1b1_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1b1_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1b1_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1b1_file1_status" @change="
                                  submitVerifikasi(
                                    'p1b1_file1_status',
                                    dataVerlap.p1b1_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1b1_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1b1_file1_status" @change="
                                  submitVerifikasi(
                                    'p1b1_file1_status',
                                    dataVerlap.p1b1_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1b1_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1b1_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11" style="text-align: justify">
                                  Semua pemrosesan permohonan perizinan berusaha
                                  sektor berdasarkan lampiran PP No. 5 Tahun
                                  2021 yang menjadi kewenangannya menggunakan
                                  sistem OSS dengan hak akses
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1b1_file2')" accept=".pdf" type="file" id="file"
                                ref="p1b1_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1b1_file2')" v-b-tooltip.hover title="Dokumen hak akses"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1b1_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1b1_file2" target="_blank">
                                <button v-if="this.dataVerlap.p1b1_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1b1_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1b1_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1b1_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1b1_file2_status" @change="
                                  submitVerifikasi(
                                    'p1b1_file2_status',
                                    dataVerlap.p1b1_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1b1_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1b1_file2_status" @change="
                                  submitVerifikasi(
                                    'p1b1_file2_status',
                                    dataVerlap.p1b1_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1b1_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Memiliki sistem dan Terintegrasi”
                                    apabila ketentuan nomor 1 terpenuhi.<br />
                                    2. Nilai “Tidak memiliki sistem dan
                                    menggunakan hak akses” apabila ketentuan
                                    nomor 2 terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="3">2</td>
                            <td rowspan="3">
                              Berapa persen tingkat verifikasi teknis dan
                              notifikasi pemenuhan standar dan persyaratan
                              Perizinan Berusaha Berbasis Risiko?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio :aria-describedby="ariaDescribedby" name="p1b2_nilai"
                                  v-model="dataVerlap.p1b2_nilai" value="25" @change="
                                    submitNilaiRadio(
                                      'p1b2_nilai',
                                      dataVerlap.p1b2_nilai
                                    )
                                    ">85 – 100%</b-form-radio>
                                <b-form-radio :aria-describedby="ariaDescribedby" name="p1b2_nilai"
                                  v-model="dataVerlap.p1b2_nilai" value="15" @change="
                                    submitNilaiRadio(
                                      'p1b2_nilai',
                                      dataVerlap.p1b2_nilai
                                    )
                                    ">70 – 84,99%</b-form-radio>
                                <b-form-radio :aria-describedby="ariaDescribedby" name="p1b2_nilai"
                                  v-model="dataVerlap.p1b2_nilai" value="10" @change="
                                    submitNilaiRadio(
                                      'p1b2_nilai',
                                      dataVerlap.p1b2_nilai
                                    )
                                    ">50 – 69,99%</b-form-radio>
                                <b-form-radio :aria-describedby="ariaDescribedby" name="p1b2_nilai"
                                  v-model="dataVerlap.p1b2_nilai" value="0" @change="
                                    submitNilaiRadio(
                                      'p1b2_nilai',
                                      dataVerlap.p1b2_nilai
                                    )
                                    ">di bawah 50%</b-form-radio>
                              </b-form-group>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1b2_file1')" accept=".pdf" type="file" id="file"
                                ref="p1b2_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1b2_file1')" v-b-tooltip.hover
                                title="Dokumen bukti permohonan risiko MT yang masuk dan verifikasinya di sistem OSS"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1b2_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1b2_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1b2_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1b2_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1b2_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1b2_nilai_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1b2_nilai_status" @change="
                                  submitVerifikasi(
                                    'p1b2_nilai_status',
                                    dataVerlap.p1b2_nilai_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1b2_nilai_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1b2_nilai_status" @change="
                                  submitVerifikasi(
                                    'p1b2_nilai_status',
                                    dataVerlap.p1b2_nilai_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1b2_nilai_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input @change="onFileChanged($event, 'p1b2_file2')" accept=".pdf" type="file" id="file"
                                ref="p1b2_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1b2_file2')" v-b-tooltip.hover
                                title="Dokumen bukti permohonan risiko T yang masuk dan verifikasinya di sistem OSS"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1b2_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1b2_file2" target="_blank">
                                <button v-if="this.dataVerlap.p1b2_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1b2_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1b2_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Penilaian verifikasi teknis dan notifikasi
                                    pemenuhan standar dan persyaratan Perizinan
                                    Berusaha Berbasis Risiko dilakukan dengan
                                    ketentuan: <br />
                                    1. Verifikasi teknis dan notifikasi
                                    pemenuhan standar oleh K/L terhadap
                                    permohonan perizinan berusaha dengan tingkat
                                    risiko Menengah Tinggi (MT) yang menjadi
                                    kewenangannya.<br />
                                    2. Verifikasi teknis dan notifikasi
                                    pemenuhan persyaratan oleh K/L terhadap
                                    permohonan perizinan berusaha dengan tingkat
                                    risiko Tinggi (T) yang menjadi
                                    kewenangannya. <br />
                                    3. Penilaian verifikasi teknis dan
                                    notifikasi pemenuhan standar dan persyaratan
                                    Perizinan Berusaha Berbasis Risiko dilakukan
                                    dengan menghitung perbandingan jumlah
                                    permohonan perizinan berusaha dengan tingkat
                                    risiko MT dan T yang telah diverifikasi
                                    dengan total permohonan perizinan berusaha
                                    yang masuk ke dalam dashboard OSS K/L
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada kegiatan monitoring dan evaluasi
                              implementasi Perizinan Berusaha?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya kegiatan monitoring dan
                              evaluasi implementasi Perizinan Berusaha dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1c1_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Kegiatan monitoring dan evaluasi dilakukan
                                  sekurang-kurangnya 1 kali dalam 1 semester
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1c1_file1')" accept=".pdf" type="file" id="file"
                                ref="p1c1_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1c1_file1')" v-b-tooltip.hover
                                title="Undangan kegitan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1c1_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1c1_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1c1_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1c1_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1c1_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1c1_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file1_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file1_status',
                                    dataVerlap.p1c1_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1c1_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1c1_file1_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file1_status',
                                    dataVerlap.p1c1_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1c1_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1c1_file2')" accept=".pdf" type="file" id="file"
                                ref="p1c1_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1c1_file2')" v-b-tooltip.hover
                                title="Undangan kegitan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1c1_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1c1_file2" target="_blank">
                                <button v-if="this.dataVerlap.p1c1_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1c1_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1c1_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1c1_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file2_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file2_status',
                                    dataVerlap.p1c1_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1c1_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1c1_file2_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file2_status',
                                    dataVerlap.p1c1_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1c1_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1c1_file3')" accept=".pdf" type="file" id="file"
                                ref="p1c1_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1c1_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1c1_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1c1_file3" target="_blank">
                                <button v-if="this.dataVerlap.p1c1_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1c1_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1c1_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1c1_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file3_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file3_status',
                                    dataVerlap.p1c1_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1c1_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1c1_file3_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file3_status',
                                    dataVerlap.p1c1_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1c1_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula Monev</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1c1_file4')" accept=".pdf" type="file" id="file"
                                ref="p1c1_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1c1_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1c1_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1c1_file4" target="_blank">
                                <button v-if="this.dataVerlap.p1c1_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1c1_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1c1_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1c1_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file4_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file4_status',
                                    dataVerlap.p1c1_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1c1_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1c1_file4_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file4_status',
                                    dataVerlap.p1c1_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1c1_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1c1_file5')" accept=".pdf" type="file" id="file"
                                ref="p1c1_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1c1_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1c1_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1c1_file5" target="_blank">
                                <button v-if="this.dataVerlap.p1c1_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1c1_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1c1_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1c1_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file5_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file5_status',
                                    dataVerlap.p1c1_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1c1_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1c1_file5_status" @change="
                                  submitVerifikasi(
                                    'p1c1_file5_status',
                                    dataVerlap.p1c1_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1c1_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada laporan kinerja implementasi Perizinan
                              Berusaha?
                            </td>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p1c2_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya laporan kinerja
                                  implementasi perizinan berusaha dilakukan
                                  dengan ketentuan apabila laporan kinerja
                                  implementasi Perizinan Berusaha dibuat secara
                                  formal dalam bentuk dokumen laporan lengkap
                                  fisik atau digital, bukan bahan presentasi dan
                                  sejenisnya
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p1c2_file1')" accept=".pdf" type="file" id="file"
                                ref="p1c2_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p1c2_file1')" v-b-tooltip.hover
                                title="Laporan (kinerja) Implementasi Perizinan Berusaha" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p1c2_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p1c2_file1" target="_blank">
                                <button v-if="this.dataVerlap.p1c2_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p1c2_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p1c2_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p1c2_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p1c2_file1_status" @change="
                                  submitVerifikasi(
                                    'p1c2_file1_status',
                                    dataVerlap.p1c2_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p1c2_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p1c2_file1_status" @change="
                                  submitVerifikasi(
                                    'p1c2_file1_status',
                                    dataVerlap.p1c2_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p1c2_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <hr />

                    <div v-if="pm.catatan_1_surveyor != null">
                      <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white"
                        align="left">
                        <template #header>
                          <h5>
                            <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                            Catatan Surveyor
                          </h5>
                        </template>
                        <div class="card-text" v-html="pm.catatan_1_surveyor"></div>
                      </b-card>
                    </div>
                    <br />
                    <div v-if="pm.catatan_1_bkpm != null">
                      <b-card border-variant="danger" header-bg-variant="danger" header-text-variant="white"
                        align="left">
                        <template #header>
                          <h5>
                            <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                            Catatan BKPM
                          </h5>
                        </template>
                        <div class="card-text" v-html="pm.catatan_1_bkpm"></div>
                      </b-card>
                    </div>
                  </div>
                  <!--end: Wizard Step 1-->

                  <!--begin: Wizard Step 2-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div style="background-color: #1bc5bd" class="card card-custom">
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Penyederhanaan
                          Perizinan Berusaha Sektor berdasarkan fakta yang ada
                          dengan memilih data yang sesuai. Dokumen lampiran yang
                          diunggah adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow">halaman pengesahan</strong>
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Unggah</th>
                            <th style="display: none">Download</th>
                            <th style="display: none">Hapus</th>
                            <th style="display: none">Pilihan</th>
                          </tr>
                        </thead>
                        <tbody>

                          <!-- Hide 2026 -->
                          <!--
                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b
                                >Penapisan bidang usaha berdasarkan tingkat
                                risiko</b
                              >
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="3">1</td>
                            <td rowspan="3">
                              Apakah ada kegiatan penapisan bidang usaha
                              berdasarkan risiko?
                            </td>
                            <td rowspan="2">
                              <b-form-group>
                                <b-form-radio
                                  name="p2a1_nilai"
                                  v-model="dataVerlap.p2a1_nilai"
                                  value="25"
                                  @change="
                                    submitNilaiRadio(
                                      'p2a1_nilai',
                                      dataVerlap.p2a1_nilai
                                    )
                                  "
                                  >Ada, semua</b-form-radio
                                >
                                <b-form-radio
                                  name="p2a1_nilai"
                                  v-model="dataVerlap.p2a1_nilai"
                                  value="10"
                                  @change="
                                    submitNilaiRadio(
                                      'p2a1_nilai',
                                      dataVerlap.p2a1_nilai
                                    )
                                  "
                                  >Ada, sebagian</b-form-radio
                                >
                                <b-form-radio
                                  name="p2a1_nilai"
                                  v-model="dataVerlap.p2a1_nilai"
                                  value="0"
                                  @change="
                                    submitNilaiRadio(
                                      'p2a1_nilai',
                                      dataVerlap.p2a1_nilai
                                    )
                                  "
                                  >Tidak ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2a1_file1')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2a1_file1')"
                                v-b-tooltip.hover
                                title="BA kegiatan penapisan"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2a1_file1 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2a1_file1" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2a1_file1 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2a1_file1 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2a1_file1')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2a1_nilai_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a1_nilai_status"
                                @change="
                                  submitVerifikasi(
                                    'p2a1_nilai_status',
                                    dataVerlap.p2a1_nilai_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2a1_nilai_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a1_nilai_status"
                                @change="
                                  submitVerifikasi(
                                    'p2a1_nilai_status',
                                    dataVerlap.p2a1_nilai_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a1_nilai_status"
                              ></b-form-select>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2a1_file2')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2a1_file2')"
                                v-b-tooltip.hover
                                title="Surat  Sekretaris Menteri Koordinator Bidang Perekonomian Nomor No. PI.01./433/SES.M.EKON/06/202"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2a1_file2 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2a1_file2" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2a1_file2 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2a1_file2 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2a1_file2')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-white">
                                  <p style="color: white">Informasi</p>
                                  Penilaian ada tidaknya kegiatan penapisan
                                  bidang usaha berdasarkan risiko dilakukan
                                  dengan ketentuan: <br />
                                  <table
                                    class="table table-borderless"
                                    style="
                                      color: white;
                                      background-color: #3699ff;
                                    "
                                  >
                                    <tr>
                                      <td>1.</td>
                                      <td>
                                        K/L melakukan penapisan pada semua KBLI
                                        yang disebutkan dalam PP No. 5 Tahun
                                        2021.
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>2.</td>
                                      <td>
                                        K/L melakukan penapisan KBLI sesuai
                                        surat Sekretaris Menteri Koordinator
                                        Bidang Perekonomian Nomor No.
                                        PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                        Juni 2021 perihal KBLI Beririsan dan
                                        KBLI Tanpa K/L Pengampu.
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>3.</td>
                                      <td>
                                        K/L yang tidak memiliki kewajiban
                                        melakukan penapisan pada KLBI sesuai
                                        surat Sekretaris Menteri Koordinator
                                        Bidang Perekonomian Nomor No.
                                        PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                        Juni 2021 perihal KBLI Beririsan dan
                                        KBLI Tanpa K/L Pengampu.
                                      </td>
                                    </tr>
                                  </table>

                                  Untuk penetapan bobot penilaian: <br />
                                  <table
                                    class="table table-borderless"
                                    style="
                                      color: white;
                                      background-color: #3699ff;
                                    "
                                  >
                                    <tr>
                                      <td width="20px">1.</td>
                                      <td colspan="2">
                                        Nilai "Ada, semua" apabila:
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td width="20px">a.</td>
                                      <td>
                                        ketentuan nomor 1 dan 2 terpenuhi.
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td>b.</td>
                                      <td>
                                        ketentuan nomor 1 dan 3 terpenuhi.
                                      </td>
                                    </tr>
                                    <tr>
                                      <td width="20px">2.</td>
                                      <td colspan="2">
                                        Nilai "Ada, sebagian" apabila:
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td width="20px">a.</td>
                                      <td>
                                        K/L melakukan penapisan pada semua KBLI
                                        yang disebutkan dalam PP No. 5 Tahun
                                        2021. Namun, tidak melakukan penapisan
                                        terhadap semua KBLI sesuai surat
                                        Sekretaris Menteri Koordinator Bidang
                                        Perekonomian Nomor No.
                                        PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                        Juni 2021 perihal KBLI Beririsan dan
                                        KBLI Tanpa K/L Pengampu, maupun
                                        sebaliknya;
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td>b.</td>
                                      <td>
                                        K/L melakukan penapisan pada sebagian
                                        KBLI yang disebutkan dalam PP No. 5
                                        Tahun 2021. Namun, telah melakukan
                                        penapisan pada semua KBLI sesuai surat
                                        Sekretaris Menteri Koordinator Bidang
                                        Perekonomian Nomor No.
                                        PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                        Juni 2021 perihal KBLI Beririsan dan
                                        KBLI Tanpa K/L, maupun sebaliknya; atau
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td>c.</td>
                                      <td>
                                        K/L melakukan penapisan pada sebagian
                                        baik atas KBLI yang disebutkan dalam PP
                                        No. 5 Tahun 2021 maupun pada KBLI sesuai
                                        surat Sekretaris Menteri Koordinator
                                        Bidang Perekonomian Nomor No.
                                        PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                        Juni 2021 perihal KBLI Beririsan dan
                                        KBLI Tanpa K/L.
                                      </td>
                                    </tr>
                                    <tr>
                                      <td width="20px">3.</td>
                                      <td colspan="2">
                                        Nilai “Tidak ada” apabila seluruh
                                        ketentuan di atas tidak terpenuhi.
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="4">2</td>
                            <td rowspan="4">
                              Apakah ada hasil penapisan bidang usaha
                              berdasarkan risiko?
                            </td>
                            <td colspan="5" style="text-align: justify">
                              Penilaian ada tidaknya hasil penapisan bidang
                              usaha berdasarkan risiko dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2a2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Tolok ukur ini sesuai dengan penilaian pada
                                  tolok ukur menilai ada tidaknya kegiatan
                                  penapisan bidang usaha berdasarkan risiko dan
                                  wajib menunjukkan dokumen hasil penapisan pada
                                  seluruh KBLI yang menjadi kewenangannya.
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2a2_file1')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2a2_file1')"
                                v-b-tooltip.hover
                                title="Dokumen hasil penapisan bidang usaha berdasarkan risiko"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2a2_file1 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2a2_file1" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2a2_file1 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2a2_file1 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2a2_file1')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2a2_file1_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a2_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2a2_file1_status',
                                    dataVerlap.p2a2_file1_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2a2_file1_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a2_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2a2_file1_status',
                                    dataVerlap.p2a2_file1_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a2_file1_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2a2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  K/L yang tidak memiliki kewajiban melakukan
                                  penapisan pada KBLI sesuai surat Sekretaris
                                  Menteri Koordinator Bidang Perekonomian Nomor
                                  No. PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                  Juni 2021 perihal KBLI Beririsan dan KBLI
                                  Tanpa K/L Pengampu.
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2a2_file2')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2a2_file2')"
                                v-b-tooltip.hover
                                title="Surat Menteri Kordinator Bidang Perekonomian"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2a2_file2 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2a2_file2" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2a2_file2 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2a2_file2 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2a2_file2')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2a2_file2_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a2_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2a2_file2_status',
                                    dataVerlap.p2a2_file2_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2a2_file2_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a2_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2a2_file2_status',
                                    dataVerlap.p2a2_file2_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2a2_file2_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, semua” apabila ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Ada, sebagian” apabila salah satu
                                    ketentuan di atas tidak terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b
                                >Penyusunan NSPK berdasarkan penapisan bidang
                                usaha</b
                              >
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada konsultasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Untuk K/L yang telah memiliki NSPK, yang dimaksud
                              dalam tolok ukur di sini adalah konsultasi dalam
                              rangka evaluasi atas NSPK yang sudah ada. Termasuk
                              penapisan pada KBLI sesuai surat Sekretaris
                              Menteri Koordinator Bidang Perekonomian Nomor No.
                              PI.01./433/SES.M.EKON/06/2021 tanggal 16 Juni 2021
                              perihal KBLI Beririsan dan KBLI Tanpa K/L
                              Pengampu. Penilaian konsultasi pengusulan NSPK
                              dengan Kementerian terkait lainnya
                              (sekurang-kurangnya melibatkan Kementerian
                              Koordinator Bidang Perekonomian, Sekretariat
                              Kabinet, atau Kementerian Investasi/BKPM)
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 6 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b1_file1')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b1_file1')"
                                v-b-tooltip.hover
                                title="Undangan kegitan konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b1_file1 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b1_file1" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b1_file1 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b1_file1 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b1_file1')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b1_file1_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file1_status',
                                    dataVerlap.p2b1_file1_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b1_file1_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file1_status',
                                    dataVerlap.p2b1_file1_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file1_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b1_file2')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b1_file2')"
                                v-b-tooltip.hover
                                title="Undangan kegitan konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b1_file2 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b1_file2" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b1_file2 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b1_file2 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b1_file2')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b1_file2_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file2_status',
                                    dataVerlap.p2b1_file2_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b1_file2_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file2_status',
                                    dataVerlap.p2b1_file2_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file2_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b1_file3')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b1_file3')"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b1_file3 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b1_file3" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b1_file3 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b1_file3 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b1_file3')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b1_file3_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file3_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file3_status',
                                    dataVerlap.p2b1_file3_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b1_file3_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file3_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file3_status',
                                    dataVerlap.p2b1_file3_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file3_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b1_file4')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b1_file4')"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b1_file4 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b1_file4" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b1_file4 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b1_file4 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b1_file4')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b1_file4_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file4_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file4_status',
                                    dataVerlap.p2b1_file4_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b1_file4_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file4_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file4_status',
                                    dataVerlap.p2b1_file4_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file4_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b1_file5')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b1_file5')"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b1_file5 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b1_file5" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b1_file5 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b1_file5 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b1_file5')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b1_file5_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file5_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file5_status',
                                    dataVerlap.p2b1_file5_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b1_file5_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file5_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b1_file5_status',
                                    dataVerlap.p2b1_file5_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b1_file5_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada harmonisasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Untuk K/L yang telah memiliki NSPK, yang dimaksud
                              dalam tolok ukur di sini adalah harmonisasi dalam
                              rangka Evaluasi atas NSPK yang sudah ada. Termasuk
                              penapisan pada KBLI sesuai surat Sekretaris
                              Menteri Koordinator Bidang Perekonomian Nomor No.
                              PI.01./433/SES.M.EKON/06/2021 tanggal 16 Juni 2021
                              perihal KBLI Beririsan dan KBLI Tanpa K/L
                              Pengampu. Penilaian harmonisasi pengusulan NSPK
                              dengan Kementerian terkait lainnya
                              (sekurang-kurangnya melibatkan Kementerian
                              Koordinator Bidang Perekonomian, Sekretariat
                              Kabinet, atau Kementerian Investasi/BKPM)
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b2_file1')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b2_file1')"
                                v-b-tooltip.hover
                                title="Undangan kegitan harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b2_file1 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b2_file1" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b2_file1 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b2_file1 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b2_file1')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b2_file1_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file1_status',
                                    dataVerlap.p2b2_file1_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b2_file1_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file1_status',
                                    dataVerlap.p2b2_file1_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file1_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b2_file2')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b2_file2')"
                                v-b-tooltip.hover
                                title="Undangan kegitan harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b2_file2 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b2_file2" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b2_file2 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b2_file2 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b2_file2')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b2_file2_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file2_status',
                                    dataVerlap.p2b2_file2_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b2_file2_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file2_status',
                                    dataVerlap.p2b2_file2_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file2_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b2_file3')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b2_file3')"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b2_file3 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b2_file3" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b2_file3 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b2_file3 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b2_file3')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b2_file3_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file3_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file3_status',
                                    dataVerlap.p2b2_file3_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b2_file3_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file3_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file3_status',
                                    dataVerlap.p2b2_file3_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file3_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b2_file4')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b2_file4')"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b2_file4 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b2_file4" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b2_file4 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b2_file4 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b2_file4')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b2_file4_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file4_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file4_status',
                                    dataVerlap.p2b2_file4_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b2_file4_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file4_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file4_status',
                                    dataVerlap.p2b2_file4_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file4_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b2_file5')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b2_file5')"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b2_file5 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b2_file5" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b2_file5 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b2_file5 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b2_file5')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b2_file5_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file5_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file5_status',
                                    dataVerlap.p2b2_file5_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b2_file5_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file5_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b2_file5_status',
                                    dataVerlap.p2b2_file5_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b2_file5_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="3">3</td>
                            <td rowspan="3">
                              Apakah ada NSPK berdasarkan penapisan bidang
                              usaha?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b3_nilai"
                                  v-model="dataVerlap.p2b3_nilai"
                                  value="25"
                                  @change="
                                    submitNilaiRadio(
                                      'p2b3_nilai',
                                      dataVerlap.p2b3_nilai
                                    )
                                  "
                                  >Ada,sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b3_nilai"
                                  v-model="dataVerlap.p2b3_nilai"
                                  value="10"
                                  @change="
                                    submitNilaiRadio(
                                      'p2b3_nilai',
                                      dataVerlap.p2b3_nilai
                                    )
                                  "
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b3_nilai"
                                  v-model="dataVerlap.p2b3_nilai"
                                  value="0"
                                  @change="
                                    submitNilaiRadio(
                                      'p2b3_nilai',
                                      dataVerlap.p2b3_nilai
                                    )
                                  "
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b3_file1')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b3_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b3_file1')"
                                v-b-tooltip.hover
                                title="Peraturan Menteri/ Peraturan Kepala Badan tentang NSPK bidang usaha"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b3_file1 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b3_file1" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b3_file1 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b3_file1 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b3_file1')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b3_nilai_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b3_nilai_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b3_nilai_status',
                                    dataVerlap.p2b3_nilai_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b3_nilai_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b3_nilai_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b3_nilai_status',
                                    dataVerlap.p2b3_nilai_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b3_nilai_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr colspan="4">
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b3_file2')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b3_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b3_file2')"
                                v-b-tooltip.hover
                                title="Rancangan Peraturan Menteri/ Peraturan Kepala Badan tentang NSPK bidang usaha"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b3_file2 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b3_file2" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b3_file2 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b3_file2 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b3_file2')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Penilaian ada tidaknya dokumen NSPK
                                    berdasarkan penapisan bidang usaha dilakukan
                                    dengan ketentuan tersedia dokumen NSPK
                                    berdasarkan penapisan bidang usaha dalam
                                    lembaran negara
                                  </p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, sudah disahkan” apabila salah
                                    satu ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, belum disahkan” apabila
                                    seluruh ketentuan di atas tidak terpenuhi
                                    namun sudah tersedia dalam bentuk
                                    naskah/dokumen usulan. <br />
                                    3. Nilai “Belum ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="8">4</td>
                            <td rowspan="8">
                              Apakah ada kegiatan sosialisasi NSPK penapisan
                              bidang usaha berdasarkan tingkat risiko?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya kegiatan sosialisasi NSPK
                              penapisan bidang usaha berdasarkan tingkat risiko
                              dilakukan dengan ketentuan
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Sosialisasi dilakukan sekurang-kurangnya 1
                                  kali dalam 1 semester
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b4_file1')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b4_file1')"
                                v-b-tooltip.hover
                                title="Undangan kegiatan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b4_file1 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b4_file1" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b4_file1 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b4_file1 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b4_file1')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b4_file1_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file1_status',
                                    dataVerlap.p2b4_file1_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b4_file1_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file1_status',
                                    dataVerlap.p2b4_file1_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file1_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Sosialisasi dilakukan secara Nasional
                                  sekurang-kurangnya dilakukan di tingkat
                                  Provinsi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b4_file2')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b4_file2')"
                                v-b-tooltip.hover
                                title="Undangan kegiatan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b4_file2 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b4_file2" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b4_file2 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b4_file2 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b4_file2')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b4_file2_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file2_status',
                                    dataVerlap.p2b4_file2_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b4_file2_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file2_status',
                                    dataVerlap.p2b4_file2_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file2_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b4_file3')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b4_file3')"
                                v-b-tooltip.hover
                                title="Undangan kegiatan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b4_file3 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b4_file3" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b4_file3 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b4_file3 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b4_file3')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b4_file3_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file3_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file3_status',
                                    dataVerlap.p2b4_file3_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b4_file3_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file3_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file3_status',
                                    dataVerlap.p2b4_file3_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file3_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b4_file4')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b4_file4')"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b4_file4 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b4_file4" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b4_file4 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b4_file4 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b4_file4')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b4_file4_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file4_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file4_status',
                                    dataVerlap.p2b4_file4_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b4_file4_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file4_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file4_status',
                                    dataVerlap.p2b4_file4_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file4_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b4_file5')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b4_file5')"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b4_file5 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b4_file5" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b4_file5 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b4_file5 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b4_file5')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b4_file5_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file5_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file5_status',
                                    dataVerlap.p2b4_file5_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b4_file5_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file5_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file5_status',
                                    dataVerlap.p2b4_file5_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file5_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p2b4_file6 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p2b4_file6')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file6"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p2b4_file6')"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2b4_file6 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2b4_file6" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p2b4_file6 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p2b4_file6 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2b4_file6')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p2b4_file6_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file6_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file6_status',
                                    dataVerlap.p2b4_file6_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p2b4_file6_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file6_status"
                                @change="
                                  submitVerifikasi(
                                    'p2b4_file6_status',
                                    dataVerlap.p2b4_file6_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p2b4_file6_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, hanya 1 kali” apabila salah
                                    satu dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        -->

                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada monitoring dan evaluasi implementasi
                              penapisan bidang usaha berdasarkan tingkat risiko?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya monitoring dan evaluasi
                              implementasi penapisan bidang usaha berdasarkan
                              tingkat risiko dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p2c1_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Kegiatan monitoring dan evaluasi dilakukan
                                  sekurang-kurangnya 1 kali dalam 1 semester
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p2c1_file1')" accept=".pdf" type="file" id="file"
                                ref="p2c1_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p2c1_file1')" v-b-tooltip.hover
                                title="Undangan kegitan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2c1_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2c1_file1" target="_blank">
                                <button v-if="this.dataVerlap.p2c1_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p2c1_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2c1_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p2c1_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file1_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file1_status',
                                    dataVerlap.p2c1_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p2c1_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p2c1_file1_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file1_status',
                                    dataVerlap.p2c1_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p2c1_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p2c1_file2')" accept=".pdf" type="file" id="file"
                                ref="p2c1_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p2c1_file2')" v-b-tooltip.hover
                                title="Undangan kegitan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2c1_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2c1_file2" target="_blank">
                                <button v-if="this.dataVerlap.p2c1_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p2c1_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2c1_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p2c1_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file2_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file2_status',
                                    dataVerlap.p2c1_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p2c1_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p2c1_file2_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file2_status',
                                    dataVerlap.p2c1_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p2c1_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p2c1_file3')" accept=".pdf" type="file" id="file"
                                ref="p2c1_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p2c1_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2c1_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2c1_file3" target="_blank">
                                <button v-if="this.dataVerlap.p2c1_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p2c1_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2c1_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p2c1_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file3_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file3_status',
                                    dataVerlap.p2c1_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p2c1_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p2c1_file3_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file3_status',
                                    dataVerlap.p2c1_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p2c1_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p2c1_file4')" accept=".pdf" type="file" id="file"
                                ref="p2c1_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p2c1_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2c1_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2c1_file4" target="_blank">
                                <button v-if="this.dataVerlap.p2c1_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p2c1_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2c1_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p2c1_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file4_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file4_status',
                                    dataVerlap.p2c1_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p2c1_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p2c1_file4_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file4_status',
                                    dataVerlap.p2c1_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p2c1_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p2c1_file5')" accept=".pdf" type="file" id="file"
                                ref="p2c1_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p2c1_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p2c1_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p2c1_file5" target="_blank">
                                <button v-if="this.dataVerlap.p2c1_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p2c1_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p2c1_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p2c1_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file5_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file5_status',
                                    dataVerlap.p2c1_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p2c1_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p2c1_file5_status" @change="
                                  submitVerifikasi(
                                    'p2c1_file5_status',
                                    dataVerlap.p2c1_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p2c1_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>

                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <hr />

                    <div v-if="pm.catatan_2_surveyor != null">
                      <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white"
                        align="left">
                        <template #header>
                          <h5>
                            <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                            Catatan Surveyor
                          </h5>
                        </template>
                        <div class="card-text" v-html="pm.catatan_2_surveyor"></div>
                      </b-card>
                    </div>
                    <br />
                    <div v-if="pm.catatan_2_bkpm != null">
                      <b-card border-variant="danger" header-bg-variant="danger" header-text-variant="white"
                        align="left">
                        <template #header>
                          <h5>
                            <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                            Catatan BKPM
                          </h5>
                        </template>
                        <div class="card-text" v-html="pm.catatan_2_bkpm"></div>
                      </b-card>
                    </div>
                  </div>
                  <!--end: Wizard Step 2-->

                  <!--begin: Wizard Step 3-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div style="background-color: #1bc5bd" class="card card-custom">
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Peningkatan Iklim
                          Investasi berdasarkan fakta yang ada dengan memilih
                          data yang sesuai. Dokumen lampiran yang diunggah
                          adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow">halaman pengesahan</strong>
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Unggah</th>
                            <th style="display: none">Download</th>
                            <th style="display: none">Hapus</th>
                            <th style="display: none">Pilihan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Unit Pelaksana PPB</b>
                            </td>
                          </tr>

                          <!-- Hide 2026 -->
                          <!-- <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">
                              Apakah ada Organisasi Pelaksana PPB?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya Organisasi Pelaksana PPB
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p3a1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  K/L memiliki dan dapat menunjukkan penetapan/
                                  keputusan dari Menteri/Kepala Lembaga
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p3a1_file1')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p3a1_file1')"
                                v-b-tooltip.hover
                                title="Surat Keputusan Menteri/ Kepala Badan tentang Pembentukan dan/atau Susunan Organisasi Pelaksana PBB"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a1_file1 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a1_file1" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p3a1_file1 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p3a1_file1 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a1_file1')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p3a1_file1_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p3a1_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p3a1_file1_status',
                                    dataVerlap.p3a1_file1_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p3a1_file1_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p3a1_file1_status"
                                @change="
                                  submitVerifikasi(
                                    'p3a1_file1_status',
                                    dataVerlap.p3a1_file1_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p3a1_file1_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="this.dataVerlap.p3a1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  >
                                  </i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  >
                                  </i>
                                </div>
                                <div class="col-11">
                                  K/L memiliki ruang sekretariat organisasi tim
                                  internal K/L yang melaksanakan tugas dan
                                  fungsi PPB
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                @change="onFileChanged($event, 'p3a1_file2')"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFiles('p3a1_file2')"
                                v-b-tooltip.hover
                                title="Ruang Sekretariat Organisasi Pelaksana PBB"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a1_file2 != null"
                                  >Unggah Ulang</span
                                ><span v-else>Unggah File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a1_file2" target="_blank">
                                <button
                                  v-if="this.dataVerlap.p3a1_file2 != null"
                                  v-b-tooltip.hover
                                  title="Unduh"
                                  type="button"
                                  size="sm"
                                  class="btn btn-success text-uppercase btn-sm text-white"
                                >
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button
                                v-if="this.dataVerlap.p3a1_file2 != null"
                                v-b-tooltip.hover
                                title="Hapus File"
                                type="button"
                                size="sm"
                                class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a1_file2')"
                              >
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                v-if="dataVerlap.p3a1_file2_status == 'Sesuai'"
                                class="text-white"
                                style="width: 150px; background-color: green"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p3a1_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p3a1_file2_status',
                                    dataVerlap.p3a1_file2_status
                                  )
                                "
                              ></b-form-select>
                              <b-form-select
                                v-else-if="
                                  dataVerlap.p3a1_file2_status == 'Tidak sesuai'
                                "
                                class="text-white"
                                style="width: 150px; background-color: red"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p3a1_file2_status"
                                @change="
                                  submitVerifikasi(
                                    'p3a1_file2_status',
                                    dataVerlap.p3a1_file2_status
                                  )
                                "
                              ></b-form-select>

                              <b-form-select
                                v-else
                                style="width: 150px"
                                :options="optionsPilihan"
                                v-model="dataVerlap.p3a1_file2_status"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila kedua ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila salah satu
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr> -->

                          <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">Apakah ada program kerja PPB?</td>
                            <td colspan="3">
                              Penilaian ada tidaknya program kerja PPB dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3a2_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  K/L memiliki dan dapat menunjukkan bukti
                                  program kerja
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3a2_file1')" accept=".pdf" type="file" id="file"
                                ref="p3a2_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3a2_file1')" v-b-tooltip.hover
                                title="Program Kerja Organisasi Pelaksana PBB" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a2_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a2_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3a2_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3a2_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a2_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3a2_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3a2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3a2_file1_status',
                                    dataVerlap.p3a2_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3a2_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3a2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3a2_file1_status',
                                    dataVerlap.p3a2_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3a2_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3a2_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  K/L memiliki dan dapat menunjukkan bukti
                                  realisasi program kerja (sekurang-kurangnya
                                  50% dari program kerja yang direncanakan)
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3a2_file2')" accept=".pdf" type="file" id="file"
                                ref="p3a2_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3a2_file2')" v-b-tooltip.hover
                                title="Laporan realisasi program kerja organisasi Pelaksana PPB" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a2_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a2_file2" target="_blank">
                                <button v-if="this.dataVerlap.p3a2_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3a2_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a2_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3a2_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3a2_file2_status" @change="
                                  submitVerifikasi(
                                    'p3a2_file2_status',
                                    dataVerlap.p3a2_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3a2_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3a2_file2_status" @change="
                                  submitVerifikasi(
                                    'p3a2_file2_status',
                                    dataVerlap.p3a2_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3a2_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila kedua ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila salah satu
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada rapat koordinasi unit pelaksana PPB?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya rapat koordinasi teragenda
                              dilakukan dengan ketentuan
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3a3_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 1 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3a3_file1')" accept=".pdf" type="file" id="file"
                                ref="p3a3_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3a3_file1')" v-b-tooltip.hover
                                title="Undangan kegiatan rapat koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a3_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a3_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3a3_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3a3_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a3_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3a3_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file1_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file1_status',
                                    dataVerlap.p3a3_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3a3_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3a3_file1_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file1_status',
                                    dataVerlap.p3a3_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3a3_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3a3_file2')" accept=".pdf" type="file" id="file"
                                ref="p3a3_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3a3_file2')" v-b-tooltip.hover
                                title="Undangan kegiatan rapat koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a3_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a3_file2" target="_blank">
                                <button v-if="this.dataVerlap.p3a3_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3a3_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a3_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3a3_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file2_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file2_status',
                                    dataVerlap.p3a3_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3a3_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3a3_file2_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file2_status',
                                    dataVerlap.p3a3_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3a3_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3a3_file3')" accept=".pdf" type="file" id="file"
                                ref="p3a3_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3a3_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a3_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a3_file3" target="_blank">
                                <button v-if="this.dataVerlap.p3a3_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3a3_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a3_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3a3_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file3_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file3_status',
                                    dataVerlap.p3a3_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3a3_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3a3_file3_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file3_status',
                                    dataVerlap.p3a3_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3a3_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3a3_file4')" accept=".pdf" type="file" id="file"
                                ref="p3a3_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3a3_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a3_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a3_file4" target="_blank">
                                <button v-if="this.dataVerlap.p3a3_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3a3_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a3_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3a3_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file4_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file4_status',
                                    dataVerlap.p3a3_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3a3_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3a3_file4_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file4_status',
                                    dataVerlap.p3a3_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3a3_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3a3_file5')" accept=".pdf" type="file" id="file"
                                ref="p3a3_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3a3_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan rapat koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3a3_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3a3_file5" target="_blank">
                                <button v-if="this.dataVerlap.p3a3_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3a3_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3a3_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3a3_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file5_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file5_status',
                                    dataVerlap.p3a3_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3a3_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3a3_file5_status" @change="
                                  submitVerifikasi(
                                    'p3a3_file5_status',
                                    dataVerlap.p3a3_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3a3_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Koordinasi Formal Lintas Pemangku
                                kepentingan</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan sesama
                              instansi Pusat?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi formal dengan
                              sesama instansi Pusat dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b1_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 6 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b1_file1')" accept=".pdf" type="file" id="file"
                                ref="p3b1_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b1_file1')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b1_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b1_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3b1_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b1_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b1_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b1_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file1_status',
                                    dataVerlap.p3b1_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b1_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b1_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file1_status',
                                    dataVerlap.p3b1_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b1_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b1_file2')" accept=".pdf" type="file" id="file"
                                ref="p3b1_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b1_file2')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b1_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b1_file2" target="_blank">
                                <button v-if="this.dataVerlap.p3b1_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b1_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b1_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b1_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file2_status',
                                    dataVerlap.p3b1_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b1_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b1_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file2_status',
                                    dataVerlap.p3b1_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b1_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b1_file3')" accept=".pdf" type="file" id="file"
                                ref="p3b1_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b1_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b1_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b1_file3" target="_blank">
                                <button v-if="this.dataVerlap.p3b1_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b1_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b1_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b1_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file3_status',
                                    dataVerlap.p3b1_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b1_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b1_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file3_status',
                                    dataVerlap.p3b1_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b1_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b1_file4')" accept=".pdf" type="file" id="file"
                                ref="p3b1_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b1_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b1_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b1_file4" target="_blank">
                                <button v-if="this.dataVerlap.p3b1_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b1_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b1_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b1_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file4_status',
                                    dataVerlap.p3b1_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b1_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b1_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file4_status',
                                    dataVerlap.p3b1_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b1_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b1_file5')" accept=".pdf" type="file" id="file"
                                ref="p3b1_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b1_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b1_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b1_file5" target="_blank">
                                <button v-if="this.dataVerlap.p3b1_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b1_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b1_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b1_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file5_status',
                                    dataVerlap.p3b1_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b1_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b1_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b1_file5_status',
                                    dataVerlap.p3b1_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b1_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan Pemerintah
                              Provinsi?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi formal dengan
                              Provinsi dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b2_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b2_file1')" accept=".pdf" type="file" id="file"
                                ref="p3b2_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b2_file1')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b2_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b2_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3b2_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b2_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b2_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b2_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file1_status',
                                    dataVerlap.p3b2_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b2_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file1_status',
                                    dataVerlap.p3b2_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b2_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b2_file2')" accept=".pdf" type="file" id="file"
                                ref="p3b2_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b2_file2')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b2_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b2_file2" target="_blank">
                                <button v-if="this.dataVerlap.p3b2_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b2_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b2_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b2_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file2_status',
                                    dataVerlap.p3b2_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b2_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b2_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file2_status',
                                    dataVerlap.p3b2_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b2_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b2_file3')" accept=".pdf" type="file" id="file"
                                ref="p3b2_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b2_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b2_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b2_file3" target="_blank">
                                <button v-if="this.dataVerlap.p3b2_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b2_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b2_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b2_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file3_status',
                                    dataVerlap.p3b2_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b2_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b2_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file3_status',
                                    dataVerlap.p3b2_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b2_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b2_file4')" accept=".pdf" type="file" id="file"
                                ref="p3b2_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b2_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b2_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b2_file4" target="_blank">
                                <button v-if="this.dataVerlap.p3b2_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b2_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b2_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b2_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file4_status',
                                    dataVerlap.p3b2_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b2_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b2_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file4_status',
                                    dataVerlap.p3b2_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b2_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b2_file5')" accept=".pdf" type="file" id="file"
                                ref="p3b2_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b2_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b2_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b2_file5" target="_blank">
                                <button v-if="this.dataVerlap.p3b2_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b2_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b2_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b2_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file5_status',
                                    dataVerlap.p3b2_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b2_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b2_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b2_file5_status',
                                    dataVerlap.p3b2_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b2_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan Pemerintah
                              Kab/Kota?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi formal dengan
                              Pemda Kabupaten/Kota dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b3_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b3_file1')" accept=".pdf" type="file" id="file"
                                ref="p3b3_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b3_file1')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b3_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b3_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3b3_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b3_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b3_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b3_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file1_status',
                                    dataVerlap.p3b3_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b3_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b3_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file1_status',
                                    dataVerlap.p3b3_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b3_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b3_file2')" accept=".pdf" type="file" id="file"
                                ref="p3b3_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b3_file2')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b3_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b3_file2" target="_blank">
                                <button v-if="this.dataVerlap.p3b3_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b3_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b3_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b3_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file2_status',
                                    dataVerlap.p3b3_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b3_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b3_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file2_status',
                                    dataVerlap.p3b3_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b3_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b3_file3')" accept=".pdf" type="file" id="file"
                                ref="p3b3_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b3_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b3_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b3_file3" target="_blank">
                                <button v-if="this.dataVerlap.p3b3_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b3_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b3_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b3_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file3_status',
                                    dataVerlap.p3b3_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b3_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b3_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file3_status',
                                    dataVerlap.p3b3_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b3_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b3_file4')" accept=".pdf" type="file" id="file"
                                ref="p3b3_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b3_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b3_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b3_file4" target="_blank">
                                <button v-if="this.dataVerlap.p3b3_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b3_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b3_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b3_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file4_status',
                                    dataVerlap.p3b3_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b3_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b3_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file4_status',
                                    dataVerlap.p3b3_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b3_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b3_file5')" accept=".pdf" type="file" id="file"
                                ref="p3b3_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b3_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b3_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b3_file5" target="_blank">
                                <button v-if="this.dataVerlap.p3b3_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b3_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b3_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b3_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file5_status',
                                    dataVerlap.p3b3_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b3_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b3_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b3_file5_status',
                                    dataVerlap.p3b3_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b3_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada koordinasi pemangku kepentingan lainnya
                              (Perbankan dan APH)?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi pemangku
                              kepentingan lainnya (Perbankan dan APH) dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b4_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b4_file1')" accept=".pdf" type="file" id="file"
                                ref="p3b4_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b4_file1')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b4_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b4_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3b4_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b4_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b4_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b4_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file1_status',
                                    dataVerlap.p3b4_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b4_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b4_file1_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file1_status',
                                    dataVerlap.p3b4_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b4_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b4_file2')" accept=".pdf" type="file" id="file"
                                ref="p3b4_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b4_file2')" v-b-tooltip.hover
                                title="Undangan kegiatan koordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b4_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b4_file2" target="_blank">
                                <button v-if="this.dataVerlap.p3b4_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b4_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b4_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b4_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file2_status',
                                    dataVerlap.p3b4_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b4_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b4_file2_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file2_status',
                                    dataVerlap.p3b4_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b4_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b4_file3')" accept=".pdf" type="file" id="file"
                                ref="p3b4_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b4_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b4_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b4_file3" target="_blank">
                                <button v-if="this.dataVerlap.p3b4_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b4_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b4_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b4_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file3_status',
                                    dataVerlap.p3b4_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b4_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b4_file3_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file3_status',
                                    dataVerlap.p3b4_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b4_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b4_file4')" accept=".pdf" type="file" id="file"
                                ref="p3b4_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b4_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b4_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b4_file4" target="_blank">
                                <button v-if="this.dataVerlap.p3b4_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b4_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b4_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b4_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file4_status',
                                    dataVerlap.p3b4_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b4_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b4_file4_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file4_status',
                                    dataVerlap.p3b4_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3b4_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3b4_file5')" accept=".pdf" type="file" id="file"
                                ref="p3b4_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3b4_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan kordinasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3b4_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3b4_file5" target="_blank">
                                <button v-if="this.dataVerlap.p3b4_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3b4_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3b4_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3b4_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file5_status',
                                    dataVerlap.p3b4_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3b4_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3b4_file5_status" @change="
                                  submitVerifikasi(
                                    'p3b4_file5_status',
                                    dataVerlap.p3b4_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3b4_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada kegiatan monitoring dan evaluasi hasil
                              peningkatan iklim investasi?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya kegiatan monitoring dan
                              evaluasi hasil peningkatan iklim investasi
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3c1_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3c1_file1')" accept=".pdf" type="file" id="file"
                                ref="p3c1_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3c1_file1')" v-b-tooltip.hover
                                title="Undangan kegiatan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3c1_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3c1_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3c1_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3c1_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3c1_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3c1_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file1_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file1_status',
                                    dataVerlap.p3c1_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3c1_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3c1_file1_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file1_status',
                                    dataVerlap.p3c1_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3c1_file2 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3c1_file2')" accept=".pdf" type="file" id="file"
                                ref="p3c1_file2" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3c1_file2')" v-b-tooltip.hover
                                title="Undangan kegiatan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3c1_file2 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3c1_file2" target="_blank">
                                <button v-if="this.dataVerlap.p3c1_file2 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3c1_file2 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3c1_file2')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3c1_file2_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file2_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file2_status',
                                    dataVerlap.p3c1_file2_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3c1_file2_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3c1_file2_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file2_status',
                                    dataVerlap.p3c1_file2_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file2_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3c1_file3 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3c1_file3')" accept=".pdf" type="file" id="file"
                                ref="p3c1_file3" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3c1_file3')" v-b-tooltip.hover title="Daftar hadir"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3c1_file3 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3c1_file3" target="_blank">
                                <button v-if="this.dataVerlap.p3c1_file3 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3c1_file3 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3c1_file3')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3c1_file3_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file3_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file3_status',
                                    dataVerlap.p3c1_file3_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3c1_file3_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3c1_file3_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file3_status',
                                    dataVerlap.p3c1_file3_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file3_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3c1_file4 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3c1_file4')" accept=".pdf" type="file" id="file"
                                ref="p3c1_file4" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3c1_file4')" v-b-tooltip.hover title="Notula" type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3c1_file4 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3c1_file4" target="_blank">
                                <button v-if="this.dataVerlap.p3c1_file4 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3c1_file4 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3c1_file4')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3c1_file4_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file4_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file4_status',
                                    dataVerlap.p3c1_file4_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3c1_file4_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3c1_file4_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file4_status',
                                    dataVerlap.p3c1_file4_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file4_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3c1_file5 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3c1_file5')" accept=".pdf" type="file" id="file"
                                ref="p3c1_file5" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3c1_file5')" v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan Monev" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3c1_file5 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3c1_file5" target="_blank">
                                <button v-if="this.dataVerlap.p3c1_file5 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3c1_file5 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3c1_file5')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3c1_file5_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file5_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file5_status',
                                    dataVerlap.p3c1_file5_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3c1_file5_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3c1_file5_status" @change="
                                  submitVerifikasi(
                                    'p3c1_file5_status',
                                    dataVerlap.p3c1_file5_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3c1_file5_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada laporan hasil monitoring peningkatan
                              iklim investasi?
                            </td>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3c2_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya laporan hasil
                                  monitoring peningkatan iklim investasi
                                  dilakukan dengan ketentuan apabila laporan
                                  hasil monitoring peningkatan iklim investasi
                                  dibuat secara formal dalam bentuk dokumen
                                  laporan lengkap fisik atau digital, bukan
                                  bahan presentasi dan sejenisnya
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3c2_file1')" accept=".pdf" type="file" id="file"
                                ref="p3c2_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3c2_file1')" v-b-tooltip.hover
                                title="Dokumen Laporan Hasil Monev peningkatan iklim investasi" type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3c2_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3c2_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3c2_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3c2_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3c2_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3c2_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3c2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3c2_file1_status',
                                    dataVerlap.p3c2_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3c2_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3c2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3c2_file1_status',
                                    dataVerlap.p3c2_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3c2_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="7" style="background-color: #ebedf3">
                              <b>Tindak lanjut atas hasil Evaluasi</b>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">1</td>
                            <td rowspan="2">
                              Apakah ada evaluasi hasil kinerja PPB tahun
                              sebelumnya?
                            </td>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3d1_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11" style="text-align: justify">
                                  <div class="row">
                                    <div class="col-12">
                                      Apakah ada evaluasi hasil kinerja PPB
                                      tahun sebelumnya?
                                    </div>
                                    <div class="col-1">1.</div>
                                    <div class="col-11">
                                      Terdapat surat undangan resmi (melibatkan
                                      pihak eksternal) dalam bentuk fisik atau
                                      digital
                                    </div>
                                    <div class="col-1">2.</div>
                                    <div class="col-11">
                                      Terdapat daftar hadir peserta rapat dalam
                                      bentuk fisik atau digital
                                    </div>
                                    <div class="col-1">3.</div>
                                    <div class="col-11">
                                      Terdapat notula rapat
                                    </div>
                                    <div class="col-1">4.</div>
                                    <div class="col-11">
                                      Terdapat dokumentasi rapat dalam bentuk
                                      foto
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3d1_file1')" accept=".pdf" type="file" id="file"
                                ref="p3d1_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3d1_file1')" v-b-tooltip.hover
                                title="Dokumen Rencana Tindak Lanjut hasil evaluasi kinerja PPB tahun sebelumnya"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3d1_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3d1_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3d1_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3d1_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3d1_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3d1_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3d1_file1_status" @change="
                                  submitVerifikasi(
                                    'p3d1_file1_status',
                                    dataVerlap.p3d1_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3d1_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3d1_file1_status" @change="
                                  submitVerifikasi(
                                    'p3d1_file1_status',
                                    dataVerlap.p3d1_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3d1_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada penambahan alokasi anggaran (rutin)
                              pelayanan perizinan berusaha?
                            </td>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i v-if="this.dataVerlap.p3d2_file1 == null" style="color: red"
                                    class="flaticon2-cross">
                                  </i>
                                  <i v-else style="color: green" class="flaticon2-check-mark">
                                  </i>
                                </div>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya penambahan alokasi
                                  anggaran (rutin) pelayanan perizinan berusaha
                                  dilakukan dengan ketentuan apabila ada
                                  penambahan alokasi anggaran (rutin) pelayanan
                                  perizinan berusaha.
                                </div>
                              </div>
                            </td>
                            <td>
                              <input @change="onFileChanged($event, 'p3d2_file1')" accept=".pdf" type="file" id="file"
                                ref="p3d2_file1" class="custom-file-input" hidden />
                              <button @click="previewFiles('p3d2_file1')" v-b-tooltip.hover
                                title="Dokumen Alokasi Anggaran Rutin Pelayanan Perizinan Tahun 2024 dan Tahun 2025"
                                type="button" style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                " size="sm" class="btn btn-primary text-uppercase btn-sm">
                                <i class="flaticon-upload"></i>
                                <span v-if="this.dataVerlap.p3d2_file1 != null">Unggah Ulang</span><span v-else>Unggah
                                  File</span>
                              </button>
                            </td>
                            <td>
                              <a :href="dataVerlap.p3d2_file1" target="_blank">
                                <button v-if="this.dataVerlap.p3d2_file1 != null" v-b-tooltip.hover title="Unduh"
                                  type="button" size="sm" class="btn btn-success text-uppercase btn-sm text-white">
                                  <i class="far fa-file-pdf"></i> Unduh File
                                </button>
                              </a>
                            </td>
                            <td>
                              <button v-if="this.dataVerlap.p3d2_file1 != null" v-b-tooltip.hover title="Hapus File"
                                type="button" size="sm" class="btn btn-danger text-uppercase btn-sm text-white"
                                @click="hapusFile('p3d2_file1')">
                                <i class="fa fa-trash"></i> Hapus File
                              </button>
                            </td>
                            <td>
                              <b-form-select v-if="dataVerlap.p3d2_file1_status == 'Sesuai'" class="text-white"
                                style="width: 150px; background-color: green" :options="optionsPilihan"
                                v-model="dataVerlap.p3d2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3d2_file1_status',
                                    dataVerlap.p3d2_file1_status
                                  )
                                  "></b-form-select>
                              <b-form-select v-else-if="
                                dataVerlap.p3d2_file1_status == 'Tidak sesuai'
                              " class="text-white" style="width: 150px; background-color: red"
                                :options="optionsPilihan" v-model="dataVerlap.p3d2_file1_status" @change="
                                  submitVerifikasi(
                                    'p3d2_file1_status',
                                    dataVerlap.p3d2_file1_status
                                  )
                                  "></b-form-select>

                              <b-form-select v-else style="width: 150px" :options="optionsPilihan"
                                v-model="dataVerlap.p3d2_file1_status"></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <div style="background-color: #3699ff" class="card card-custom">
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <hr />

                    <div v-if="pm.catatan_3_surveyor != null">
                      <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white"
                        align="left">
                        <template #header>
                          <h5>
                            <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                            Catatan Surveyor
                          </h5>
                        </template>
                        <div class="card-text" v-html="pm.catatan_3_surveyor"></div>
                      </b-card>
                    </div>
                    <br />
                    <div v-if="pm.catatan_3_bkpm != null">
                      <b-card border-variant="danger" header-bg-variant="danger" header-text-variant="white"
                        align="left">
                        <template #header>
                          <h5>
                            <i class="fa fa-info-circle" style="color: white" aria-hidden="true"></i>
                            Catatan BKPM
                          </h5>
                        </template>
                        <div class="card-text" v-html="pm.catatan_3_bkpm"></div>
                      </b-card>
                    </div>
                  </div>
                  <!--end: Wizard Step 3-->

                  <div class="pb-5" data-wizard-type="step-content" style="margin-top: -40px">
                    <h4 class="mb-10 font-weight-bold text-dark">
                      Bukti Verifikasi
                    </h4>

                    <div class="my-5">
                      <div class="card card-custom">
                        <div class="card-body">
                          <!--begin: Datatable-->
                          <div class="form-group row">
                            <label class="col-lg-4 col-form-label">Nama Pendamping dari K/L</label>
                            <div class="col-lg-8">
                              <input type="text" v-model="dataVerlap.nama_pendamping"
                                placeholder="Nama Pendamping dari K/L" class="form-control" />
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-lg-4 col-form-label">Nomor Hp Pendamping</label>
                            <div class="col-lg-8">
                              <input type="text" v-model="dataVerlap.nomor_pendamping" class="form-control"
                                v-on:input="filterInput" />
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-lg-4 col-form-label">Lattitude</label>
                            <div class="col-lg-8">
                              <input type="text" v-model="latitude" class="form-control" />
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-lg-4 col-form-label">Longtitude</label>
                            <div class="col-lg-8">
                              <input type="text" v-model="longtitude" class="form-control" />
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-lg-4 col-form-label"></label>
                            <div class="col-lg-8">
                              <div class="row">
                                <div class="col-xl-12">
                                  <!--begin::Input-->
                                  <div class="form-group">
                                    <label>Upload Foto Bersama Pendamping</label>
                                    <div></div>
                                    <b-form-file v-model="dataVerlap.fotoBukti" accept="image/*" type="file"
                                      ref="file"></b-form-file>
                                  </div>
                                  <div v-if="dataVerlap.foto != null">
                                    <b-img :src="dataVerlap.foto" style="height: 100px" fluid alt="Foto"></b-img>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--begin: Wizard Actions -->
                  <div class="d-flex justify-content-between border-top pt-10">
                    <div class="mr-2">
                      <button class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-prev">
                        Sebelumnya
                      </button>
                    </div>
                    <div>
                      <button v-on:click="submit" class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-submit">
                        Submit
                      </button>
                      <button class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-next" @click="simpanSementara()">
                        Simpan Sementara
                      </button>
                    </div>
                  </div>
                  <!--end: Wizard Actions -->
                </form>
                <!--end: Wizard Form-->
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Bpdy-->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-verlapppb.scss";
</style>


<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";

import axios from "axios";

import qs from "qs";

import VueLoading from "vuejs-loading-plugin";
import Vue from "vue";

Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

export default {
  name: "ppbkl-detail",
  mounted() {
    this.$forceUpdate();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: localStorage.getItem("nama_wilayah"), route: "verifikasi" },
      { title: "Verifikasi PPB" },
    ]);

    // Initialize form wizard
    const wizard = new KTWizard("kt_wizard_v4", {
      startStep: 1, // initial active step number
      clickableSteps: false, // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function (/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    this.loadVerlap();
    this.getlocation();
  },
  data() {
    return {
      url: localStorage.getItem("baseapi"),
      token: localStorage.getItem("id_token"),
      id_ptsp: localStorage.getItem("idptsp"),
      tahun: new Date().getFullYear(),
      user: JSON.parse(localStorage.getItem("user")),
      bagian: [
        { value: "kadis", text: "Kepala Dinas" },
        { value: "kabidpb", text: "Kepala Bidang Perizinan Berusaha" },
        { value: "kasiepb", text: "Kepala Seksi Bidang Perizinan Berusaha" },
        {
          value: "foffpb",
          text: "Staf Front-office Bidang Perizinan Berusaha",
        },
        { value: "boffpb", text: "Staf Back-office Bidang Perizinan Berusaha" },
        { value: "hdeskpb", text: "Staf Help Desk Bidang Perizinan Berusaha" },
        { value: "kabiddal", text: "Kepala Bidang Dalaks" },
        { value: "kasiedal", text: "Kepala Seksi Bidang Dalaks" },
        { value: "foffdal", text: "Staf Front-office Bidang Dalaks" },
        { value: "boffdal", text: "Staf Back-office Bidang Dalaks" },
        { value: "hdeskdal", text: "Staf Help Desk Bidang Dalaks" },
      ],
      dataVerlap: {},
      optionsPilihan: [
        { value: "Belum diverifikasi", text: "Belum diverifikasi" },
        { value: "Sesuai", text: "Sesuai" },
        { value: "Tidak sesuai", text: "Tidak sesuai" },
      ],
      location: null,
      gettingLocation: false,
      errorStr: null,
      latitude: "",
      longtitude: "",
      pm: {},
    };
  },
  methods: {
    filterInput(event) {
      const input = event.target.value;
      const filteredInput = input.replace(/[^0-9+\-()]/g, "");
      this.dataVerlap.nomor_pendamping = filteredInput;
    },
    simpanSementara() {
      var wizard = new KTWizard("kt_wizard_v4");

      //console.log(wizard.currentStep)
      if (wizard.currentStep === 1) {
        if (
          this.dataVerlap.p1a1_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a1_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a1_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a1_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a1_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a2_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a2_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a2_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a2_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a2_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a3_nilai_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a4_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a4_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a4_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a4_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p1a4_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p1b1_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p1b1_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p1b2_nilai_status != "Belum diverifikasi" &&
          this.dataVerlap.p1c1_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p1c1_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p1c1_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p1c1_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p1c1_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p1c2_file1_status != "Belum diverifikasi"
        ) {
          this.verifikasiFinal();
        } else {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: "Silahkan isi semua form!",
          });
          wizard.stop();
        }
      } else if (wizard.currentStep === 2) {
        if (
          // this.dataVerlap.p2a1_nilai_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2a2_file1_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2a2_file2_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b1_file1_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b1_file2_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b1_file3_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b1_file4_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b1_file5_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b2_file1_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b2_file2_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b2_file3_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b2_file4_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b2_file5_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b3_nilai_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b4_file1_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b4_file2_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b4_file3_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b4_file4_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b4_file5_status != "Belum diverifikasi" &&
          // this.dataVerlap.p2b4_file6_status != "Belum diverifikasi" &&
          this.dataVerlap.p2c1_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p2c1_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p2c1_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p2c1_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p2c1_file5_status != "Belum diverifikasi"
        ) {
          this.verifikasiFinal();
        } else {
          wizard.stop();
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: "Silahkan isi semua form!",
          });
        }
      } else if (wizard.currentStep === 3) {
        if (
          // this.dataVerlap.p3a1_file1_status != "Belum diverifikasi" &&
          // this.dataVerlap.p3a1_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3a2_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3a2_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3a3_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3a3_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3a3_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p3a3_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p3a3_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b1_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b1_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b1_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b1_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b1_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b2_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b2_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b2_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b2_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b2_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b3_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b3_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b3_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b3_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b3_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b4_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b4_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b4_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b4_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.p3b4_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p3c1_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3c1_file2_status != "Belum diverifikasi" &&
          this.dataVerlap.p3c1_file3_status != "Belum diverifikasi" &&
          this.dataVerlap.p3c1_file4_status != "Belum diverifikasi" &&
          this.dataVerlap.c1_file5_status != "Belum diverifikasi" &&
          this.dataVerlap.p3c2_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3d1_file1_status != "Belum diverifikasi" &&
          this.dataVerlap.p3d2_file1_status != "Belum diverifikasi"
        ) {
          this.verifikasiFinal();
        } else {
          wizard.stop();
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: "Silahkan isi semua form!",
          });
        }
      }
    },
    verifikasiFinal() {
      var wizard = new KTWizard("kt_wizard_v4");
      const idptsp = this.id_ptsp;
      const tahun = this.tahun;
      const url = this.url;
      const token = this.token;

      // Change event
      wizard.on("change", function (e) {
        const formData = {
          form: e.currentStep,
          idkl: idptsp,
          tahun: tahun,
        };
        axios
          .put(url + "/verifikasi_ppb_kl_2026_final", qs.stringify(formData), {
            // _method: 'patch',
            headers: {
              xth: token,
              "content-type": "application/x-www-form-urlencoded",
            },
          })
          .then((response) => {
            return response;
          })
          .catch((error) => {
            return error;
          });
        setTimeout(() => {
          KTUtil.scrollTop();
        }, 500);
      });
    },
    submit: function (e) {
      e.preventDefault();
      if (
        this.latitude == "" ||
        this.longtitude == "" ||
        (this.dataVerlap.fotoBukti == null && this.dataVerlap.foto == null) ||
        this.dataVerlap.nama_pendamping == null ||
        this.dataVerlap.nomor_pendamping == null
      ) {
        Swal.fire({
          icon: "error",
          title: "Gagal..",
          text: "Pastikan semua data bukti verifikasi terisi",
        });
      } else {
        Swal.fire({
          title: "Perhatian",
          text: "Apakah Anda ingin menyelesaikan dan mengirim hasil Verifikasi Lapangan?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
        }).then((result) => {
          if (result.isConfirmed) {
            let formData = new FormData();
            if (this.dataVerlap.fotoBukti) {
              formData.append("foto", this.dataVerlap.fotoBukti);
            }
            formData.append("latitude", this.latitude);
            formData.append("longtitude", this.longtitude);
            formData.append("nama_pendamping", this.dataVerlap.nama_pendamping);
            formData.append(
              "nomor_pendamping",
              this.dataVerlap.nomor_pendamping
            );
            formData.append("nama_surveyor", this.user.name);
            // formData.append('nama_user', this.user.name);
            // tampak_depan
            axios
              .post(
                this.url +
                "/verifikasi_ppb_kl_2026_bukti/" +
                this.dataVerlap.id,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    xth: this.token,
                  },
                }
              )
              .then((response) => {
                this.$bvToast.toast("Berhasil Disimpan", {
                  title: `Success `,
                  variant: `success`,
                  solid: true,
                });
                this.$router.push("/verifikasi/ppbkl");
                return response;
              })
              .catch((error) => {
                console.log(error);
                this.$bvToast.toast(error.response.data.message, {
                  title: `Failed `,
                  variant: `danger`,
                  solid: true,
                });
                return error;
              });
          }
        });
      }
    },
    loadVerlap() {
      axios
        .get(
          this.url +
          "/verifikasi_ppb_kl_2026?filter=idkl,=," +
          this.id_ptsp +
          ";tahun,=," +
          this.tahun,
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          this.dataVerlap = response.data.data[0];
          //console.log(this.dataVerlap)
        });

      axios
        .get(
          this.url +
          "/pm_ppb_kl_2026?filter=idkl,=," +
          this.id_ptsp +
          ";tahun,=," +
          this.tahun,
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          this.pm = response.data.data[0];
          //console.log(this.dataVerlap)
        });
    },
    previewFiles(data) {
      // Form 1
      if (data == "p1a1_file1") {
        this.$refs.p1a1_file1.click();
      } else if (data == "p1a1_file2") {
        this.$refs.p1a1_file2.click();
      } else if (data == "p1a1_file3") {
        this.$refs.p1a1_file3.click();
      } else if (data == "p1a1_file4") {
        this.$refs.p1a1_file4.click();
      } else if (data == "p1a1_file5") {
        this.$refs.p1a1_file5.click();
      } else if (data == "p1a2_file1") {
        this.$refs.p1a2_file1.click();
      } else if (data == "p1a2_file2") {
        this.$refs.p1a2_file2.click();
      } else if (data == "p1a2_file3") {
        this.$refs.p1a2_file3.click();
      } else if (data == "p1a2_file4") {
        this.$refs.p1a2_file4.click();
      } else if (data == "p1a2_file5") {
        this.$refs.p1a2_file5.click();
      } else if (data == "p1a3_file1") {
        this.$refs.p1a3_file1.click();
      } else if (data == "p1a3_file2") {
        this.$refs.p1a3_file2.click();
      } else if (data == "p1a4_file1") {
        this.$refs.p1a4_file1.click();
      } else if (data == "p1a4_file2") {
        this.$refs.p1a4_file2.click();
      } else if (data == "p1a4_file3") {
        this.$refs.p1a4_file3.click();
      } else if (data == "p1a4_file4") {
        this.$refs.p1a4_file4.click();
      } else if (data == "p1a4_file5") {
        this.$refs.p1a4_file5.click();
      } else if (data == "p1b1_file1") {
        this.$refs.p1b1_file1.click();
      } else if (data == "p1b1_file2") {
        this.$refs.p1b1_file2.click();
      } else if (data == "p1b2_file1") {
        this.$refs.p1b2_file1.click();
      } else if (data == "p1b2_file2") {
        this.$refs.p1b2_file2.click();
      } else if (data == "p1c1_file1") {
        this.$refs.p1c1_file1.click();
      } else if (data == "p1c1_file2") {
        this.$refs.p1c1_file2.click();
      } else if (data == "p1c1_file3") {
        this.$refs.p1c1_file3.click();
      } else if (data == "p1c1_file4") {
        this.$refs.p1c1_file4.click();
      } else if (data == "p1c1_file5") {
        this.$refs.p1c1_file5.click();
      } else if (data == "p1c2_file1") {
        this.$refs.p1c2_file1.click();
      }

      // Form 2
      else if (data == "p2a1_file1") {
        this.$refs.p2a1_file1.click();
      } else if (data == "p2a1_file2") {
        this.$refs.p2a1_file2.click();
      } else if (data == "p2a2_file1") {
        this.$refs.p2a2_file1.click();
      } else if (data == "p2a2_file2") {
        this.$refs.p2a2_file2.click();
      } else if (data == "p2b1_file1") {
        this.$refs.p2b1_file1.click();
      } else if (data == "p2b1_file2") {
        this.$refs.p2b1_file2.click();
      } else if (data == "p2b1_file3") {
        this.$refs.p2b1_file3.click();
      } else if (data == "p2b1_file4") {
        this.$refs.p2b1_file4.click();
      } else if (data == "p2b1_file5") {
        this.$refs.p2b1_file5.click();
      } else if (data == "p2b2_file1") {
        this.$refs.p2b2_file1.click();
      } else if (data == "p2b2_file2") {
        this.$refs.p2b2_file2.click();
      } else if (data == "p2b2_file3") {
        this.$refs.p2b2_file3.click();
      } else if (data == "p2b2_file4") {
        this.$refs.p2b2_file4.click();
      } else if (data == "p2b2_file5") {
        this.$refs.p2b2_file5.click();
      } else if (data == "p2b3_file1") {
        this.$refs.p2b3_file1.click();
      } else if (data == "p2b3_file2") {
        this.$refs.p2b3_file2.click();
      } else if (data == "p2b4_file1") {
        this.$refs.p2b4_file1.click();
      } else if (data == "p2b4_file2") {
        this.$refs.p2b4_file2.click();
      } else if (data == "p2b4_file3") {
        this.$refs.p2b4_file3.click();
      } else if (data == "p2b4_file4") {
        this.$refs.p2b4_file4.click();
      } else if (data == "p2b4_file5") {
        this.$refs.p2b4_file5.click();
      } else if (data == "p2b4_file6") {
        this.$refs.p2b4_file6.click();
      } else if (data == "p2c1_file1") {
        this.$refs.p2c1_file1.click();
      } else if (data == "p2c1_file2") {
        this.$refs.p2c1_file2.click();
      } else if (data == "p2c1_file3") {
        this.$refs.p2c1_file3.click();
      } else if (data == "p2c1_file4") {
        this.$refs.p2c1_file4.click();
      } else if (data == "p2c1_file5") {
        this.$refs.p2c1_file5.click();
      }

      // Form 3
      else if (data == "p3a1_file1") {
        this.$refs.p3a1_file1.click();
      } else if (data == "p3a1_file2") {
        this.$refs.p3a1_file2.click();
      } else if (data == "p3a2_file1") {
        this.$refs.p3a2_file1.click();
      } else if (data == "p3a2_file2") {
        this.$refs.p3a2_file2.click();
      } else if (data == "p3a3_file1") {
        this.$refs.p3a3_file1.click();
      } else if (data == "p3a3_file2") {
        this.$refs.p3a3_file2.click();
      } else if (data == "p3a3_file3") {
        this.$refs.p3a3_file3.click();
      } else if (data == "p3a3_file4") {
        this.$refs.p3a3_file4.click();
      } else if (data == "p3a3_file5") {
        this.$refs.p3a3_file5.click();
      } else if (data == "p3b1_file1") {
        this.$refs.p3b1_file1.click();
      } else if (data == "p3b1_file2") {
        this.$refs.p3b1_file2.click();
      } else if (data == "p3b1_file3") {
        this.$refs.p3b1_file3.click();
      } else if (data == "p3b1_file4") {
        this.$refs.p3b1_file4.click();
      } else if (data == "p3b1_file5") {
        this.$refs.p3b1_file5.click();
      } else if (data == "p3b2_file1") {
        this.$refs.p3b2_file1.click();
      } else if (data == "p3b2_file2") {
        this.$refs.p3b2_file2.click();
      } else if (data == "p3b2_file3") {
        this.$refs.p3b2_file3.click();
      } else if (data == "p3b2_file4") {
        this.$refs.p3b2_file4.click();
      } else if (data == "p3b2_file5") {
        this.$refs.p3b2_file5.click();
      } else if (data == "p3b3_file1") {
        this.$refs.p3b3_file1.click();
      } else if (data == "p3b3_file2") {
        this.$refs.p3b3_file2.click();
      } else if (data == "p3b3_file3") {
        this.$refs.p3b3_file3.click();
      } else if (data == "p3b3_file4") {
        this.$refs.p3b3_file4.click();
      } else if (data == "p3b3_file5") {
        this.$refs.p3b3_file5.click();
      } else if (data == "p3b4_file1") {
        this.$refs.p3b4_file1.click();
      } else if (data == "p3b4_file2") {
        this.$refs.p3b4_file2.click();
      } else if (data == "p3b4_file3") {
        this.$refs.p3b4_file3.click();
      } else if (data == "p3b4_file4") {
        this.$refs.p3b4_file4.click();
      } else if (data == "p3b4_file5") {
        this.$refs.p3b4_file5.click();
      } else if (data == "p3c1_file1") {
        this.$refs.p3c1_file1.click();
      } else if (data == "p3c1_file2") {
        this.$refs.p3c1_file2.click();
      } else if (data == "p3c1_file3") {
        this.$refs.p3c1_file3.click();
      } else if (data == "p3c1_file4") {
        this.$refs.p3c1_file4.click();
      } else if (data == "p3c1_file5") {
        this.$refs.p3c1_file5.click();
      } else if (data == "p3c2_file1") {
        this.$refs.p3c2_file1.click();
      } else if (data == "p3d1_file1") {
        this.$refs.p3d1_file1.click();
      } else if (data == "p3d2_file1") {
        this.$refs.p3d2_file1.click();
      }
    },
    onFileChanged(e, data) {
      console.log(data);
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);

        this.$bvToast.toast("File terlalu besar, pilih file maksimal 500KB", {
          title: `Failed `,
          variant: `danger`,
          solid: true,
        });
        this.selectedFile = null;
      } else {
        this.$loading(true);
        let formData = new FormData();
        formData.append(data, this.selectedFile);
        axios
          .post(
            this.url + "/verifikasi_ppb_kl_2026/" + this.dataVerlap.id,
            formData,
            {
              // _method: 'patch',
              headers: {
                xth: this.token,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);
            this.loadVerlap();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
      }
    },

    submitNilaiRadio(data, nilai) {
      let formData = new FormData();
      formData.append(data, nilai);
      console.log(data + nilai);
      axios
        .post(
          this.url + "/verifikasi_ppb_kl_2026/" + this.dataVerlap.id,
          formData,
          {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          // this.$loading(false);
          // this.$bvToast.toast('Berhasil Verifikasi', {
          //     title: `Success `,
          //     variant: `success`,
          //     solid: true
          // })
          // console.log(response);
          this.loadVerlap();

          return response;
        })
        .catch((error) => {
          // console.log(error)
          // this.$loading(false);
          // this.$bvToast.toast('Gagal Verifikasi', {
          //     title: `Failed `,
          //     variant: `danger`,
          //     solid: true
          // })
          return error;
        });
    },

    submitVerifikasi(data, value) {
      let formData = new FormData();
      formData.append(data, value);
      axios
        .post(
          this.url + "/verifikasi_ppb_kl_2026/" + this.dataVerlap.id,
          formData,
          {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          this.$bvToast.toast("Berhasil Verifikasi", {
            title: `Success `,
            variant: `success`,
            solid: true,
          });
          // console.log(response);
          this.loadVerlap();

          return response;
        })
        .catch((error) => {
          console.log(error);
          this.$loading(false);
          this.$bvToast.toast("Gagal Verifikasi", {
            title: `Failed `,
            variant: `danger`,
            solid: true,
          });
          return error;
        });
    },

    hapusFile(data) {
      // let formData = new FormData();
      // formData.append('field', data);
      // formData.append('idptsp', this.dataVerlap.idptsp);
      // formData.append('tahun', this.tahun);
      console.log(this.dataVerlap.idkl);

      Swal.fire({
        title: "Apakah Anda yakin?",
        text: "Anda tidak bisa mengembalikan file ini",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya, Hapus File",
      }).then((result) => {
        if (result.isConfirmed) {
          const formData = {
            field: data,
            idptsp: this.dataVerlap.idkl,
            tahun: this.tahun,
          };
          axios
            .put(
              this.url + "/verifikasi_ppb_kl_2026_delete_lampiran",
              qs.stringify(formData),
              {
                // _method: 'patch',
                headers: {
                  xth: this.token,
                  "content-type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((response) => {
              this.$loading(false);
              this.$bvToast.toast("Berhasil hapus file", {
                title: `Success `,
                variant: `success`,
                solid: true,
              });
              // console.log(response);
              this.loadVerlap();

              return response;
            })
            .catch((error) => {
              console.log(error);
              this.$loading(false);
              this.$bvToast.toast("Gagal hapus file", {
                title: `Failed `,
                variant: `danger`,
                solid: true,
              });
              return error;
            });
        }
      });
    },

    getlocation() {
      if (!("geolocation" in navigator)) {
        this.errorStr = "Geolocation is not available.";
        return;
      }

      this.gettingLocation = true;
      // get position
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gettingLocation = false;
          this.location = pos;
          this.latitude = pos.coords.latitude;
          this.longtitude = pos.coords.longitude;
          console.log(this.latitude);
          console.log(this.longtitude);
        },
        (err) => {
          this.gettingLocation = false;
          this.errorStr = err.message;
        }
      );
    },

    async openFile(url) {
      const exists = await this.checkFile(url);

      if (exists) {
        window.open(url, "_blank");
      } else {
        this.$bvToast.toast("File tidak ditemukan, silahkan unggah file baru", {
          title: `Failed `,
          variant: `danger`,
          solid: true,
        });
      }
    },
    async checkFile(url) {
      try {
        await axios.head(url); // tidak download file
        console.log("File tersedia");
        return true;

      } catch (err) {
        if (err.response && err.response.status === 404) {
          console.log("File tidak ditemukan (404)");
        } else {
          console.log("Error lain:", err.message);
        }
        return false;
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 760px),
(min-device-width: 768px) and (max-device-width: 768px) {

  /* Force table to not be like tables anymore */
  table,
  thead,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 10px 1rem 1rem 1rem;
  }

  /* tr:nth-child(odd) {
      background: #E1EDFF;
    } */

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    /* padding-left: 50%; */
  }

  th {
    display: none;
  }

  /* td:before { */
  /* Now like a table header */
  /* position: absolute; */
  /* Top/left values mimic padding */
  /* top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap; */
  /* } */

  /*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/
  /* td:nth-of-type(1):before { content: "No"; }
		td:nth-of-type(2):before { content: "Indikator"; }
		td:nth-of-type(3):before { content: "Status"; }
		td:nth-of-type(4):before { content: "Jawaban"; }
        td:nth-of-type(5):before { content: "Unggah"; } 
        td:nth-of-type(6):before { content: "Download"; }  */
}
</style>